import Commands from "./commands";

class Div extends Commands {
    constructor(registry) {
        super("div", registry);
    }

    async execute(node, emitter, options) {
        const param1 = await emitter(node.params[0], options);
        const param2 = await emitter(node.params[1], options);
        if (typeof (param1) !== typeof (param2)) {
            console.error("Params type are not the same");
            return undefined;
        }
        return parseFloat(param1) / parseFloat(param2);
    }
}

export default Div;
